import _classCallCheck from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/tomi/Documents/projects/cf/react-vaadin-components/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import './custom-elements-es5-adapter';
export var CustomElement = /*#__PURE__*/function (_Component) {
  _inherits(CustomElement, _Component);

  function CustomElement() {
    var _this;

    _classCallCheck(this, CustomElement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CustomElement).call(this));
    _this.state = {};
    _this.propertyBlacklist = ['children', 'tagName'];
    _this.attributeWhitelist = ['theme', 'style'];
    return _this;
  }

  _createClass(CustomElement, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var attributes = {};
      Object.keys(this.props).filter(function (key) {
        return key.indexOf('aria-') === 0 || _this2.attributeWhitelist.indexOf(key) !== -1;
      }).forEach(function (key) {
        return attributes[key] = _this2.props[key];
      });
      return React.createElement(this.tagName || this.props.tagName, Object.assign(attributes, {
        ref: function ref(element) {
          if (_this2._element) {
            // Remove existing event listeners
            for (var eventName in _this2._eventListeners) {
              _this2._element.removeEventListener(eventName, _this2._eventListeners[eventName]);
            }
          }

          _this2._element = element;

          if (!element) {
            return;
          }

          _this2._eventListeners = {};

          for (var prop in _this2.props) {
            if (/^on[A-Z]/.test(prop)) {
              var _eventName = prop.replace(/([A-Z])/g, function (name) {
                return "-".concat(name[0].toLowerCase());
              }).replace('on-', '');

              _this2._eventListeners[_eventName] = _this2.props[prop];
            } else if (_this2.propertyBlacklist.indexOf(prop) === -1 && !attributes.hasOwnProperty(prop)) {
              element[prop] = _this2.props[prop];
            }
          } // Add the event listeners after setting the properties


          for (var _eventName2 in _this2._eventListeners) {
            element.addEventListener(_eventName2, _this2._eventListeners[_eventName2]);
          }

          _this2._configRef && _this2._configRef(element);
        }
      }), this._children || this.props.children);
    }
  }]);

  return CustomElement;
}(Component);
export var CustomElementIs = function CustomElementIs(tagName) {
  return /*#__PURE__*/function (_CustomElement) {
    _inherits(Clazz, _CustomElement);

    function Clazz() {
      var _this3;

      _classCallCheck(this, Clazz);

      _this3 = _possibleConstructorReturn(this, _getPrototypeOf(Clazz).call(this));
      _this3.tagName = tagName;
      return _this3;
    }

    return Clazz;
  }(CustomElement);
};